// joku "const p5js = require(p5) tms
import textFit from 'textFit';

// require('optical-kerning');

export default class Etusivu {
  constructor() {
    console.log('Etusivu constructed');

    $('.dia--showtime').each(function(){
      let maxw = window.innerWidth > 800 ? Math.random()*60 : Math.random()*30;
      let maxh = window.innerWidth > 800 ? 2 + Math.random()*40 : 8 + Math.random()*30;
      $(this).css({
        'left' : maxw+'%',
        'top' : maxh+'%',
      });
    });

    $('.dia--description').each(function(){
      $(this).css({
        'left' : Math.random()*65+'%',
        'bottom' : 6 + 2 + Math.random()*35+'%',
      });
    });

    $('.dia').first().addClass('in');
    $('.dia').first().find('.dia--names--name').first().addClass('in');

    $('html, body').scrollLeft(0);

    setTimeout(function(){
      $('html, body').scrollLeft(0);
    }, 100);

    $(window).on('pageshow load', function(){
      $('html, body').scrollLeft(0);

      setTimeout(function(){
        $('html, body').scrollLeft(0);
      }, 10);
    });

    window.loopNames = setInterval(function(){
      diaNames();
    }, 2000);

    function diaNames(){
      $('.dia.in').each(function(){
        var cur = $(this).find('.dia--names--name.in');
        var next = cur.next('.dia--names--name');
        var tar = null;
        if(next.length>0) {
          tar = next;
        } else {
          tar = $(this).find('.dia--names--name').first();
        }
        $(this).find('.dia--names--name.in').removeClass('in').addClass('out');
        $(tar).siblings().not(cur).removeClass('out');
        $(tar).addClass('in');
      });
    }

    if(!window.kosketus) {
      // no kosketus
      $('.nav a').mouseenter(function(e){
        $(this).addClass('hov');
        $(this).children('span').css({
          'left' : e.offsetX,
          'top' : e.offsetY,
        });
      }).mousemove(function(e){
        $(this).children('span').css({
          'left' : e.offsetX,
          'top' : e.offsetY,
        });
      }).mouseleave(function(){
        $(this).removeClass('hov');
      });

      $('.nav a').click(function(e){
        e.preventDefault();
        var dir = $(this).attr('data-dir');
        var tar = false;
        if(dir=='right') {
          if($('.dia.in').next('.dia').length>0) {
            tar = $('.dia.in').next('.dia');
          }
        } else {
          if($('.dia.in').prev('.dia').length>0) {
            tar = $('.dia.in').prev('.dia');
          }
        }
        if(tar) {
          $('.nav .hov').removeClass('hov');
          $('.nav a').removeClass('disabled');

          $('.dia.out').removeClass('out');
          if(dir=='right') {
            $('.dia.in').addClass('out').removeClass('in');
          } else {
            $('.dia.in').removeClass('in');
          }
          $('.dia--names--name').removeClass('in');
          $(tar).addClass('in');
          clearInterval(window.loopNames);
          diaNames();
          window.loopNames = setInterval(function(){
            diaNames();
          }, 2000);

          if($('.dia.in').next('.dia').length==0) {
            $('.nav a.right').addClass('disabled');
          }

          if($('.dia.in').prev('.dia').length==0) {
            $('.nav a.left').addClass('disabled');
          }
        }
      });
    } else {
      $('#main-content').scroll(function(){
        $('.dia').each(function(){
          let winx = window.innerWidth;
          var rect = this.getBoundingClientRect();
          if(rect.left > -winx*.25 && rect.right < winx*1.25) {
            if(!$(this).hasClass('in')){
              $(this).addClass('in').removeClass('out');
              clearInterval(window.loopNames);
              diaNames();
              window.loopNames = setInterval(function(){
                diaNames();
              }, 2000);
            }
          } else {
            if(rect.right < winx) {
              $(this).addClass('out').removeClass('in');
            } else {
              $(this).removeClass('in');
            }
          }
        })
      });
    }

    textFits();

    $(window).on('resize', textFits);

    function textFits(){
      $('.name').each(function(){
        var h = $(this).parent().outerHeight();
        var w = $(this).parent().outerWidth();

        $(this).css({
          'height' : parseInt(h),
          'width' : parseInt(w),
        });

        textFit(
          this,
          {
            multiLine: true,
            minFontSize: 100,
            maxFontSize: 900,
          }
        );

        /*
        $(this).kerning({
          factor: 0.6,
          // exclude: [[0x00, 0xFF]]
        });
        */
        // $(this).textFit();
      });
    }
  }
}
